var map = {
	"./avatar.png": 4937,
	"./checkIcon.png": 935,
	"./first.png": 9186,
	"./left.png": 4585,
	"./right.png": 6194,
	"./three.png": 5364,
	"./title.png": 6414,
	"./two.png": 5366,
	"./wuxian.png": 4306
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9573;